/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import React from 'react';

import Thumbnail from 'components/Thumbnail';

import { FilePropType } from 'propTypes/common';
import { useLightbox } from 'hooks/useLightbox';

import styles from './styles.module.scss';

const Infographic = ({ image }) => {
	const [lightbox, showLightbox] = useLightbox([image]);

	return (
		<>
			<div className={styles.infographic} onClick={showLightbox}>
				<Thumbnail
					file={image}
					params={{
						width: image.width,
						height: image.height
					}}
					keepRatio
				/>
			</div>

			{lightbox}
		</>
	);
};

Infographic.propTypes = {
	image: FilePropType.isRequired
};

export default Infographic;
